import { scrollToSection, scrollToSectionMobile } from "@/lib/general.utils";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

const StepsComponent = () => {
    const { t } = useTranslation();
    const [width, setWidth] = useState<number | null>(
        typeof window !== "undefined" ? window?.innerWidth : null
    );

    function handleWindowSizeChange() {
        setWidth(window?.innerWidth);
    }
    useEffect(() => {
        if (typeof window !== "undefined")
            window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            if (typeof window !== "undefined")
                window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    const isMobile = width ? width <= 768 : false;
    const router = useRouter();
    return (
        <div
            style={{ direction: "rtl" }}
            className="w-full h-auto md:h-[90rem] mt-[4rem] text-primary child:flex child:items-center child:justify-center py-[5rem] px-[2rem] md:px-[8rem] mx-auto md:max-w-[120rem] relative"
        >
            <div className="text-[2rem] font-bold">{t("home.steps.title")}</div>
            <div className="text-[1.5rem] font-thin mt-[1rem] text-center text-[#636363]">
                <p className="w-[80%]">{t("home.steps.subtitle")}</p>
            </div>
            <div className="flex md:grid flex-wrap  grid-cols-3 mt-[5rem] md:mt-[10rem] gap-[5.5rem]  w-full h-auto md:h-[26rem] relative text-[1rem]">
                <div className="border-primary border-[0.10rem] w-full md:h-full h-[25rem]  rounded-[1.2rem] grid grid-rows-3 child:flex child:items-center child:justify-center">
                    <div className="flex flex-col row-span-2 relative">
                        <div className="absolute -top-[2.5rem] w-[3.7rem] h-[3.7rem] pb-[0.2rem] rounded-full text-[2rem] flex items-center justify-center bg-primary text-[white]">
                            1
                        </div>
                        <div className="bg-[#00B8FF] rounded-full p-[0.5rem]">
                            <Image
                                data-aos="zoom-in"
                                src={"/steps/step-1.svg"}
                                width={1000}
                                height={1000}
                                alt="step-1"
                                className="w-[7rem]"
                            />
                        </div>
                        <div className="font-bold text-[1.5rem] mt-[0.5rem]">
                            {t("home.steps.step1.title")}
                        </div>
                    </div>
                    <div className="text-center text-[#636363] text-[1.2rem] !items-start">
                        <p className="text-center w-[80%]">
                            {t("home.steps.step1.description")}
                        </p>
                    </div>
                </div>

                <div className="border-primary border-[0.10rem] w-full md:h-full h-[25rem] rounded-[1.2rem] grid grid-rows-3 child:flex child:items-center child:justify-center">
                    <div className="flex flex-col row-span-2 relative">
                        <div className="absolute -top-[2.5rem] w-[3.7rem] h-[3.7rem] pb-[0.2rem] rounded-full text-[2rem] flex items-center justify-center bg-primary text-[white]">
                            2
                        </div>
                        <div className="bg-[#00B8FF] rounded-full p-[0.5rem]">
                            <Image
                                data-aos="zoom-in"
                                src={"/steps/step-2.svg"}
                                width={1000}
                                height={1000}
                                alt="step-2"
                                className="w-[7rem]"
                            />
                        </div>
                        <div className="font-bold text-[1.5rem] mt-[0.5rem]">
                            {t("home.steps.step2.title")}
                        </div>
                    </div>
                    <div className="text-center text-[#636363] text-[1.2rem] !items-start">
                        <p className="text-center w-[80%]">
                            {t("home.steps.step2.description")}
                        </p>
                    </div>
                </div>

                <div className="border-primary border-[0.10rem] w-full md:h-full h-[25rem] rounded-[1.2rem] grid grid-rows-3 child:flex child:items-center child:justify-center">
                    <div className="flex flex-col row-span-2 relative">
                        <div className="absolute -top-[2.5rem] w-[3.7rem] h-[3.7rem] pb-[0.2rem] rounded-full text-[2rem] flex items-center justify-center bg-primary text-[white]">
                            3
                        </div>
                        <div className="bg-[#00B8FF] rounded-full p-[0.5rem]">
                            <Image
                                data-aos="zoom-in"
                                src={"/steps/step-3.svg"}
                                width={1000}
                                height={1000}
                                alt="step-3"
                                className="w-[7rem]"
                            />
                        </div>
                        <div className="font-bold text-[1.5rem] mt-[0.5rem]">
                            {t("home.steps.step3.title")}
                        </div>
                    </div>
                    <div className="text-center text-[#636363] text-[1.2rem] !items-start">
                        <p className="text-center w-[80%]">
                            {t("home.steps.step3.description")}
                        </p>
                    </div>
                </div>
                {/* 
                <Image
                    data-aos="fade-left"
                    data-aos-duration="700"
                    src={"/steps/left-arrow.svg"}
                    width={1000}
                    height={1000}
                    alt="left-arrow"
                    className="w-[10rem] absolute -top-[4rem] right-[27rem] hidden md:block"
                />
                <Image
                    data-aos="fade-left"
                    src={"/steps/left-arrow.svg"}
                    width={1000}
                    height={1000}
                    alt="left-arrow"
                    className="w-[10rem] absolute -top-[4rem] left-[27rem] hidden md:block"
                />
                <Image
                    data-aos="fade-down"
                    src={"/steps/down-arrow.svg"}
                    width={1000}
                    height={1000}
                    alt="down-arrow"
                    className="w-[3rem] absolute top-[20rem] -left-[3rem] hidden md:block"
                /> */}
            </div>

            <div className="flex md:grid flex-wrap flex-col-reverse grid-cols-3 mt-[3.5rem] md:mt-[10rem] gap-[5.5rem] w-full h-auto md:h-[26rem] relative  text-[1rem]">
                <div className="w-full md:h-full h-[25rem] rounded-[1.2rem] grid grid-rows-3 child:flex child:items-center child:justify-center">
                    <div className="flex flex-col row-span-1 relative"></div>
                    <div className="grid-rows-2 h-full row-span-2 relative flex items-end">
                        <div className="grid-rows-3 child:flex child:items-end child:justify-center">
                            <div className="row-span-2">
                                <div className="rounded-full p-[0.5rem]">
                                    <Image
                                        data-aos="fade-right"
                                        src={"/steps/step-sign.svg"}
                                        width={1000}
                                        height={1000}
                                        alt="step-sign"
                                        className="w-[7rem]"
                                    />
                                </div>
                            </div>
                            <div>
                                <div
                                    onClick={() => {
                                        isMobile
                                            ? window.open(
                                                  "https://onelink.to/bzaaarz-partner",
                                                  "_blank"
                                              )
                                            : router.push("/sign");
                                    }}
                                    data-aos="fade-right"
                                    data-aos-duration="700"
                                    className="font-thin text-[1.5rem] cursor-pointer bg-secondary h-[4rem]  pb-[0.2rem] px-[1rem] text-[white] rounded-full flex items-center justify-center"
                                >
                                    {t("home.steps.signUp")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-primary border-[0.10rem] w-full md:h-full h-[25rem] rounded-[1.2rem] grid grid-rows-3 child:flex child:items-center child:justify-center">
                    <div className="flex flex-col row-span-2 relative">
                        <div className="absolute -top-[2.5rem] w-[3.7rem] h-[3.7rem] pb-[0.2rem] rounded-full text-[2rem] flex items-center justify-center bg-primary text-[white]">
                            5
                        </div>
                        <div className="bg-[#00B8FF] rounded-full p-[0.5rem]">
                            <Image
                                data-aos="zoom-in"
                                src={"/steps/step-5.svg"}
                                width={1000}
                                height={1000}
                                alt="step-5"
                                className="w-[7rem]"
                            />
                        </div>
                        <div className="font-bold text-[1.5rem] mt-[0.5rem]">
                            {t("home.steps.step5.title")}
                        </div>
                    </div>
                    <div className="text-center text-[#636363] text-[1.2rem] !items-start">
                        <p className="text-center w-[80%]">
                            {t("home.steps.step5.description")}
                        </p>
                    </div>
                </div>

                <div className="border-primary border-[0.10rem] w-full md:h-full h-[25rem] rounded-[1.2rem] grid grid-rows-3 child:flex child:items-center child:justify-center">
                    <div className="flex flex-col row-span-2 relative">
                        <div className="absolute -top-[2.5rem] w-[3.7rem] h-[3.7rem] pb-[0.2rem] rounded-full text-[2rem] flex items-center justify-center bg-primary text-[white]">
                            4
                        </div>
                        <div className="bg-[#00B8FF] rounded-full p-[0.5rem]">
                            <Image
                                data-aos="zoom-in"
                                src={"/steps/step-4.svg"}
                                width={1000}
                                height={1000}
                                alt="step-4"
                                className="w-[7rem]"
                            />
                        </div>
                        <div className="font-bold text-[1.5rem] mt-[0.5rem]">
                            {t("home.steps.step4.title")}
                        </div>
                    </div>
                    <div className="text-center text-[#636363] text-[1.2rem] !items-start">
                        <p className="text-center w-[80%]">
                            {t("home.steps.step4.description")}
                        </p>
                    </div>
                </div>

                {/* <Image
                    data-aos="fade-right"
                    src={"/steps/down-right-arrow.svg"}
                    width={1000}
                    height={1000}
                    alt="down-right-arrow"
                    className="w-[10rem] absolute -top-[3rem] right-[28rem] hidden md:block "
                />
                <Image
                    data-aos="fade-right"
                    src={"/steps/right-arrow.svg"}
                    width={1000}
                    height={1000}
                    alt="right-arrow"
                    className="w-[10rem] absolute -top-[4rem] left-[27rem] hidden md:block"
                /> */}
            </div>
            <Image
                src={"/icons/dots.svg"}
                width={1000}
                height={1000}
                alt="dots"
                className="w-[8rem] absolute bottom-0 -left-[2rem] hidden md:block"
            />
            <Image
                src={"/icons/smoke-1.svg"}
                width={1000}
                height={1000}
                alt="smoke"
                className="w-[40rem] absolute -top-[5rem] -right-[2rem]"
            />
        </div>
    );
};

export default StepsComponent;
